import * as React from 'react'

const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 23 27"
    className="design-iconfont"
    {...props}
  >
    <defs>
      <linearGradient x1="50%" y1="0%" x2="50%" y2="98.993%" id="mbhrwirqrb">
        <stop stopColor="#4AB6F5" offset="0%" />
        <stop stopColor="#227BF9" offset="100%" />
      </linearGradient>
      <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="fdx1dxau7a">
        <stop stopColor="#7DCFFF" offset="0%" />
        <stop stopColor="#60A2FE" offset="100%" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path
        d="M11.5.821c2.85 0 5.43 1.155 7.297 3.023a10.287 10.287 0 0 1 3.023 7.297c0 2.468-1.54 5.495-3.44 8.161-2.494 3.499-5.655 6.52-6.88 6.52-1.225 0-4.386-3.021-6.88-6.52-1.9-2.666-3.44-5.693-3.44-8.161 0-2.85 1.155-5.43 3.023-7.297A10.287 10.287 0 0 1 11.5.82Z"
        stroke="url(#fdx1dxau7a)"
        fill="url(#mbhrwirqrb)"
      />
      <path
        d="M14.292 8.2v6.92c0 .044.037.08.083.08h.458a.082.082 0 0 0 .084-.08V9.28c0-.044.037-.08.083-.08h.75c.46 0 .833.358.833.8v5.12c0 .044.038.08.084.08h.25c.045 0 .083.036.083.08v.64c0 .044-.037.08-.083.08H7.083A.082.082 0 0 1 7 15.92v-.64c0-.044.037-.08.083-.08h.459a.082.082 0 0 0 .083-.08V8.2c0-.663.56-1.2 1.25-1.2h4.167c.69 0 1.25.537 1.25 1.2Zm-2.35 2.8h-1.885c-.031 0-.057.06-.057.133v.734c0 .073.026.133.057.133h1.886c.031 0 .057-.06.057-.133v-.734c0-.073-.026-.133-.057-.133Zm.978-2H9.08c-.044 0-.08.06-.08.133v.734c0 .073.036.133.08.133h3.84c.044 0 .08-.06.08-.133v-.734C13 9.06 12.964 9 12.92 9Z"
        fill="#E2F2FF"
        fillRule="nonzero"
      />
    </g>
  </svg>
)

export default SvgComponent
